import { PRODUCT_TYPES, type ProductType } from "@jipraks/shared";
import { cn } from "@client/lib/cn";
import { catalogCopy } from "@client/locales/id/catalog";

interface ProductTypeFilterProps {
  value: ProductType | undefined;
  onChange: (value: ProductType | undefined) => void;
  /** Types that actually have products; the rest are hidden. */
  availableTypes: ProductType[];
}

const PILL =
  "min-h-11 shrink-0 rounded-full border px-4 text-sm transition-all duration-200 ease-expo-out";

export function ProductTypeFilter({ value, onChange, availableTypes }: ProductTypeFilterProps) {
  const types = PRODUCT_TYPES.filter((type) => availableTypes.includes(type));
  const options: Array<ProductType | undefined> = [undefined, ...types];

  return (
    // Scrolls inside itself on narrow screens — never the page (TECH.md §8.1).
    <div
      role="group"
      aria-label={catalogCopy.filterLabel}
      className="-mx-4 flex gap-2 overflow-x-auto px-4 pb-1 [scrollbar-width:none] sm:mx-0 sm:flex-wrap sm:px-0"
    >
      {options.map((option) => {
        const isActive = option === value;
        return (
          <button
            key={option ?? "all"}
            type="button"
            aria-pressed={isActive}
            onClick={() => onChange(option)}
            className={cn(
              PILL,
              isActive
                ? "border-border-accent bg-accent-soft text-foreground shadow-inner-highlight"
                : "border-border-default bg-surface text-foreground-muted hover:border-border-hover hover:text-foreground",
            )}
          >
            {option ? catalogCopy.productTypes[option] : catalogCopy.filterAll}
          </button>
        );
      })}
    </div>
  );
}
